<template>
  <section class="user-list">
    <Popup
      v-if="filePopup.opened"
      title="Добавить абонентов через файл"
      @close="onFilePopupClose"
      @approve="onFilePopupApprove"
    >
      <p>
        Загрузите файл с SIP-аккаунтами в формате csv. <br />
        После загрузки файла каждой квартире адреса будет назначен
        соответствующий файлу SIP-аккаунт для вызова.
      </p>
      <FormFile v-model="filePopup.file" label="Загрузить файл с абонентами" />
    </Popup>

    <Popup
      v-if="clientPopup.opened"
      :title="clientPopup.title"
      :subTitle="clientPopup.subTitle"
      @close="onClientPopupClose"
      @approve="onClientPopupApprove"
    >
      <FormList v-model="clientPopup.value" :list="clientPopup.list" />
    </Popup>
    <IntercomDisconnectConfirm
      v-if="gateDisconnectConfirm.active"
      :address-name="currentAddress"
      :loading="gateDisconnectConfirm.loading"
      @approve="onGateDisconnectApprove"
      @close="gateDisconnectConfirm.active = false"
    />
    <div class="user-list__filters">
      <Filters v-model="filtersActive" :filters="filters" />
    </div>
    <div class="user-list__list">
      <Table
        v-model="rowsSelected"
        :columns="tableColumns"
        :rows="tableRows"
        @switcherClick="onSwitcherClick"
        @rowClick="onRowClick"
      />
      <Pagination
        v-model="contactsMeta.current_page"
        v-bind="{
          totalItems: contactsMeta.total,
          itemsByPage: contactsMeta.per_page,
        }"
        @switchPage="onSwitchPage"
      />
    </div>
    <div class="user-list__actions">
      <Actions
        :actions="rowsSelected.length ? actions.selected : actions.default"
      />
    </div>
  </section>
</template>

<script>
import Popup from '../../components/Popup.vue'
import Filters from '../../components/Filters.vue'
import Table from '../../components/Table.vue'
import Actions from '../../components/Actions.vue'
import MockIntercomAddress from '../../mixins/Mock/MockIntercomAddress.js'
import FormFile from '../../components/Form/File.vue'
import FormList from '../../components/Form/List.vue'
import Pagination from '../../components/Pagination.vue'
import IntercomDisconnectConfirm from '../Popup/IntercomDisconnectConfirm.vue'

export default {
  name: 'AddressList',
  mixins: [MockIntercomAddress],
  components: {
    Popup,
    Filters,
    Table,
    Actions,
    FormFile,
    FormList,
    Pagination,
    IntercomDisconnectConfirm,
  },
  data() {
    return {
      filtersActive: {},
      rowsSelected: [],
    }
  },
  watch: {
    filtersActive: {
      handler(value) {
        if (value.status === null) {
          value.status = ''
        }

        this.filterContacts(value)
      },
      deep: true,
    },
  },
  computed: {
    contactsMeta() {
      return this.$store.getters['contactsMeta']
    },
  },
}
</script>

<style lang="scss" scoped>
.user-list {
  width: 100%;

  &__filters,
  &__list {
    margin: 0 $space-md $space-lg;
  }
}
</style>
